import React, { useEffect, useCallback } from "react";
import { tokens } from "../../theme";
import {
  Box,
  IconButton,
  useTheme,
  Button,
  CircularProgress,
} from "@mui/material";
import Loading from "../../components/Loading";
// import Header from "../../components/Header";
import Axios from "axios";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import PotentialStudentsHorizView from "./PotentialStudentsHorizView";
import Alert from "../../components/alert/Alert";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import getCookie from "../../utils/getCookies";

const ConsultationProgress = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // for 401 error
  const signOut = useSignOut();
  const navigate = useNavigate();
  const handleLogout = () => {
    signOut();
    localStorage.removeItem("userName");
    localStorage.removeItem("who");
    navigate("/signin");
  };

  // for alert
  const [successAlertOpen, setSuccessAlertOpen] = React.useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = React.useState("");
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = React.useState("");

  const [loading, setLoading] = React.useState(true);
  const [search, setSearch] = React.useState(""); // search by consultation number
  const [parentPhoneNumberSearch, setParentPhoneNumberSearch] =
    React.useState(""); // search by parent phone number
  const [emailSearch, setEmailSearch] = React.useState(""); // search by parent email
  const [studentEmailSearch, setStudentEmailSearch] = React.useState(""); // search by student email
  const [studentNameSearch, setStudentNameSearch] = React.useState(""); // search by student name
  const [studentPhoneNumberSearch, setStudentPhoneNumberSearch] =
    React.useState(""); // search by student phone number
  const [memoSearch, setMemoSearch] = React.useState(""); // search by memo
  const [hasTaskSearch, setHasTaskSearch] = React.useState(""); // search by has task
  const [isSentSearch, setIsSentSearch] = React.useState(""); // search by is sent
  const [searchMethodHistory, setSearchMethodHistory] = React.useState(""); // search method history
  const [searchValueHistory, setSearchValueHistory] = React.useState(""); // search value history

  const [studentUpdated, setStudentUpdated] = React.useState(false);
  const [students, setStudents] = React.useState([]);

  // Pagination state for infinite scroll
  const [offset, setOffset] = React.useState(0);
  const [hasMore, setHasMore] = React.useState(true);
  const [isLoadingMore, setIsLoadingMore] = React.useState(false);

  // store previous actions for horizontal view
  const [prevActions, setPrevActions] = React.useState([]);

  const [lastUpdate, setLastUpdate] = React.useState(Date.now());

  const [currentUser, setCurrentUser] = React.useState(null);
  React.useEffect(() => {
    const fetchCurrentUser = async () => {
        const token = getCookie('_auth');
        const response = await Axios.get(`${process.env.REACT_APP_URL}/api/v1/admins/current-user`, {
            headers: {
            Authorization: `Bearer ${token}`,
        },
        });
        setCurrentUser(response.data);
    };
    fetchCurrentUser();
}, []);
  const fetchStudents = useCallback(
    async (method, param, value, append = false) => {
      if (method === "enter" && !value) {
        setErrorAlertMessage("Please enter a search value");
        setErrorAlertOpen(true);
        return;
      }

      let searchValue = "";
      if(value){
        searchValue = value;
      }else{
        searchValue =
          method === "enter"
          ? value
          : param === "consultation_number"
          ? search
          : param === "parent_phone_number"
          ? parentPhoneNumberSearch
          : param === "parent_email"
          ? emailSearch
          : param === "student_email"
          ? studentEmailSearch
          : param === "student_name"
          ? studentNameSearch?.toLowerCase()
          : param === "student_phone_number"
          ? studentPhoneNumberSearch
          : param === "student_memo"
          ? memoSearch
          : value;
      }

      if (param !== "num_of_people") {
        setSearchMethodHistory(param);
        setSearchValueHistory(searchValue);
      }else{
        switch(param){
          case "num_of_people":
            setSearchMethodHistory("num_of_people");
            setSearchValueHistory(15);
            break;
          case "has_task":
            setSearchMethodHistory("has_task");
            setSearchValueHistory(true);
            break;
          case "is_sent":
            setSearchMethodHistory("is_sent");
            setSearchValueHistory(false);
            break;
        }
      }

      let url = `${process.env.REACT_APP_URL}/api/v1/students/consultation-progress`;

      if (param !== "num_of_people") {
        if (!searchValue && method === "click") {
          setErrorAlertMessage("Please enter a search value");
          setErrorAlertOpen(true);
          return;
        }
        url += `?${param}=${searchValue}`;
      } else {
        url += `?num_of_people=${value || 15}`;
        // Add offset for pagination if appending
        if (append) {
          url += `&offset=${offset}`;
        }
      }

      try {
        if (append) {
          setIsLoadingMore(true);
        }

        const response = await Axios.get(url, {
          headers: {
            Authorization: `Bearer ${getCookie('_auth')}`,
          },
        });

        // Handle paginated response for num_of_people
        if (param === "num_of_people" && response.data.students) {
          const { students: newStudents, hasMore: moreAvailable } = response.data;

          if (append) {
            setStudents(prev => [...prev, ...newStudents]);
            setOffset(prev => prev + newStudents.length);
          } else {
            setStudents(newStudents);
            setOffset(newStudents.length);
          }

          setHasMore(moreAvailable);
        } else {
          // Handle non-paginated response (other search methods)
          setStudents(response.data);
          setHasMore(false);
        }

        emptySearch();
      } catch (error) {
        if (error.response?.status === 404) {
          if (!append) {
            setStudents([]);
          }
          setHasMore(false);
          setErrorAlertMessage("No student found");
          setErrorAlertOpen(true);
        } else if (error.response?.status === 401) {
          handleLogout();
        }
      } finally {
        if (append) {
          setIsLoadingMore(false);
        }
      }
    },
    [
      search,
      parentPhoneNumberSearch,
      emailSearch,
      studentEmailSearch,
      studentNameSearch,
      studentPhoneNumberSearch,
      memoSearch,
      studentUpdated,
      offset,
    ]
  );

  // Function to load more students for infinite scroll
  const loadMoreStudents = useCallback(() => {
    if (searchMethodHistory === "num_of_people" && hasMore && !isLoadingMore) {
      fetchStudents("loading", "num_of_people", searchValueHistory, true);
    }
  }, [searchMethodHistory, hasMore, isLoadingMore, searchValueHistory, fetchStudents]);

  useEffect(() => {
    const init = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const consultationNumber = searchParams.get("consultation_number");

      // Reset pagination state
      setOffset(0);
      setHasMore(true);

      if (consultationNumber) {
        await fetchStudents("enter", "consultation_number", consultationNumber);
        setSearchMethodHistory("consultation_number");
        setSearchValueHistory(consultationNumber);
      } else {
        await fetchStudents("loading", "num_of_people", "15");
        setSearchMethodHistory("num_of_people");
        setSearchValueHistory(15);
      }
      setLoading(false);
    };
    init();
  }, []);


  React.useEffect(() => {
    const consultationNumElement = document.getElementById(
      "consultation_number"
    );
    if (!loading && consultationNumElement) {
      consultationNumElement.focus();
    }
  }, [loading]);

  // Enter key handler
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        const activeElement = document.activeElement;

        // Don't hijack Enter while typing in a memo. The rich-text memo editors are
        // contentEditable <div>s (no "memo-textarea" class), so allow a normal newline
        // for any contentEditable field as well as the legacy textarea.
        if (
          activeElement?.isContentEditable ||
          activeElement?.classList.contains("memo-textarea") ||
          document.activeElement?.id === "filled-basic memo-textarea"
        ) {
          return;
        }
        e.preventDefault();

        const now = Date.now();
        if (now - lastUpdate < 1000) return;
        setLastUpdate(now);

        if (!activeElement?.id) return;

        switch (activeElement.id) {
          case "consultation_number":
            fetchStudents("click", "consultation_number");
            break;
          case "parent_phone_number":
            fetchStudents("click", "parent_phone_number");
            break;
          case "parent_email":
            fetchStudents("click", "parent_email");
            break;
          case "student_email":
            fetchStudents("click", "student_email");
            break;
          case "student_name":
            fetchStudents("click", "student_name");
            break;
          case "student_phone_number":
            fetchStudents("click", "student_phone_number");
            break;
          case "student_memo":
            fetchStudents("click", "student_memo");
            break;
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [fetchStudents, lastUpdate]);

  useEffect(()=>{
    if (studentUpdated){
      if(searchMethodHistory === 'num_of_people' || searchMethodHistory === 'has_task' || searchMethodHistory === 'is_sent'){
        fetchStudents('loading', searchMethodHistory, searchValueHistory);
      }else{
        fetchStudents('enter', searchMethodHistory, searchValueHistory);
      }
    }
    setStudentUpdated(false);
  }, [studentUpdated]);

  function updatePotentialStudentsInfo(student_uuid, updatedInfo) {
    Axios.put(
      `${process.env.REACT_APP_URL}/api/v1/students/${student_uuid}`,
      {
        ...updatedInfo,
      },
      {
        headers: {
          Authorization: `Bearer ${getCookie('_auth')}`,
        },
      }
    ).catch((error) => {
      if (error.response?.status === 401) {
        handleLogout();
        return;
      }
      alert(error.response?.data?.message || "Something went wrong");
    });
  }

  function updateMemo(student_uuid, memo_id, updatedInfo) {
    Axios.put(
      `${process.env.REACT_APP_URL}/api/v1/students/${student_uuid}/memos/${memo_id}`,
      {
        ...updatedInfo,
      },
      {
        headers: {
          Authorization: `Bearer ${getCookie('_auth')}`,
        },
      }
    ).catch((error) => {
      if (error.response?.status === 401) {
        handleLogout();
        return;
      }
      alert(error.response?.data?.message || "Something went wrong");
    });
  }

  function emptySearch() {
    setSearch("");
    setParentPhoneNumberSearch("");
    setEmailSearch("");
    setStudentEmailSearch("");
    setStudentNameSearch("");
    setStudentPhoneNumberSearch("");
    setMemoSearch("");
  }

  if (loading) return <CircularProgress />;

  return (
    <Box
      m="20px"
      marginX={3}
      marginY={3}
      sx={{
        minHeight: "88%",
      }}
    >
      {/* <Header title="Potential Students" subtitle="A ONE Institute" /> */}
      {loading ? (
        <Loading />
      ) : (
        <>
          <Box
            display="flex"
            justifyContent="left"
            gap={1}
            p={0}
            minHeight={70}
            mb={2}
            flexWrap={"wrap"}
          >
            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOffset(0);
                  setHasMore(true);
                  fetchStudents("loading", "num_of_people", 15);
                }}
              >
                Show First 15
              </Button>
            </Box>
            {/* SEARCH BAR */}
            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                placeholder="Search by consultation number"
                id="consultation_number"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "consultation_number")}
              >
                <SearchIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setParentPhoneNumberSearch(e.target.value)}
                value={parentPhoneNumberSearch}
                placeholder="Search by parent phone"
                id="parent_phone_number"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "parent_phone_number")}
              >
                <SearchIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setEmailSearch(e.target.value)}
                value={emailSearch}
                placeholder="Search by parent email"
                id="parent_email"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "parent_email")}
              >
                <SearchIcon />
              </IconButton>
            </Box>
            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setStudentEmailSearch(e.target.value)}
                value={studentEmailSearch}
                placeholder="Search by student email"
                id="student_email"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "student_email")}
              >
                <SearchIcon />
              </IconButton>
            </Box>
            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setStudentNameSearch(e.target.value)}
                value={studentNameSearch}
                placeholder="Search by student name"
                id="student_name"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "student_name")}
              >
                <SearchIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setStudentPhoneNumberSearch(e.target.value)}
                value={studentPhoneNumberSearch}
                placeholder="Search by student phone"
                id="student_phone_number"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "student_phone_number")}
              >
                <SearchIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
              maxWidth={240}
              minWidth={240}
            >
              <InputBase
                sx={{ ml: 2, flex: 1 }}
                onChange={(e) => setMemoSearch(e.target.value)}
                value={memoSearch}
                placeholder="Search by memo"
                id="student_memo"
              />
              <IconButton
                type="button"
                sx={{ p: 1 }}
                onClick={() => fetchStudents("click", "student_memo")}
              >
                <SearchIcon />
              </IconButton>
            </Box>
            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#ffffff",
                  "&:hover": { backgroundColor: "#ffffff" },
                }}
                onClick={() => fetchStudents("loading", "has_task", true)}
              >
                <CancelScheduleSendIcon
                  fontSize="small"
                  color="warning"
                  sx={{ cursor: "pointer" }}
                />
              </Button>
            </Box>
            <Box
              display="flex"
              backgroundColor={colors.primary[600]}
              borderRadius="3px"
              boxShadow={10}
              mb={1}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#ffffff",
                  "&:hover": { backgroundColor: "#ffffff" },
                }}
                onClick={() => fetchStudents("loading", "is_sent", false)}
              >
                <CancelScheduleSendIcon
                  fontSize="small"
                  color="error"
                  sx={{ cursor: "pointer" }}
                />
              </Button>
            </Box>
          </Box>
          <PotentialStudentsHorizView
            students={students}
            search={search}
            emailSearch={emailSearch}
            setStudentUpdated={setStudentUpdated}
            setPrevActions={setPrevActions}
            prevActions={prevActions}
            updatePotentialStudentsInfo={updatePotentialStudentsInfo}
            updateMemo={updateMemo}
            currentUser={currentUser}
            loadMoreStudents={loadMoreStudents}
            hasMore={hasMore}
            isLoadingMore={isLoadingMore}
          />
        </>
      )}
      <Alert
        successAlertOpen={successAlertOpen}
        setSuccessAlertOpen={setSuccessAlertOpen}
        errorAlertOpen={errorAlertOpen}
        setErrorAlertOpen={setErrorAlertOpen}
        successMsg={successAlertMessage}
        errorMsg={errorAlertMessage}
        vertical="bottom"
        horizontal="left"
      />
    </Box>
  );
};

export default ConsultationProgress;
